import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect, useLocation, useParams } from 'react-router'
import { Link } from 'react-router-dom'

import { selectCurrentHotelId, selectCurrentHotels } from '../../accessors/index'
import {
  getSubsidiaryList,
  postAndSelectSubsidiary,
  savePrevPath
} from '../../actions/index'
import LoadingIndicator from '../../components/ReusableComponents/LoadingIndicator'
import { saveSubsidiary } from '../../utils/helpers'
import { resolveSubsidiaryFromList } from './resolveSubsidiaryFromList'

const SwitchToHotelAndGoToPath = () => {
  const dispatch = useDispatch()

  const { subsidiaryId: idFromUrl } = useParams()
  let location = useLocation()

  const prevPath = useSelector(s => s.login.prevPath)

  const pathToGo = `${location.pathname}${location.search}`.match(
    /^\/s\/[a-zA-Z-0-9]+(\/.+)$/
  )[1]

  const currentSubsidiaryId = useSelector(selectCurrentHotelId)

  const currentSubsidiaryList = useSelector(selectCurrentHotels)

  const isLoggedIn = useSelector(s => s.login.userLoggedIn)
  const isSubsidiaryPosting = useSelector(s => s.login.isSubsidiaryPosting)
  const subsidiaryListError = useSelector(s => s.login.subsidiaryListError)

  const [hasNoAccess, setHasNoAccess] = useState(false)
  const [hasRequestedList, setHasRequestedList] = useState(false)

  const resolvedHotel = resolveSubsidiaryFromList(currentSubsidiaryList, idFromUrl)
  const resolvedSubsidiaryId = resolvedHotel?.subsidiaryId
    ? String(resolvedHotel.subsidiaryId)
    : null

  useEffect(() => {
    if (!isLoggedIn) {
      return
    }

    if (currentSubsidiaryList.length === 0 && !hasRequestedList && !subsidiaryListError) {
      setHasRequestedList(true)
      dispatch(getSubsidiaryList())
    }
  }, [
    isLoggedIn,
    currentSubsidiaryList.length,
    hasRequestedList,
    subsidiaryListError,
    dispatch
  ])

  useEffect(() => {
    if (!isLoggedIn || isSubsidiaryPosting) {
      return
    }

    if (currentSubsidiaryList.length === 0) {
      if (subsidiaryListError) {
        setHasNoAccess(true)
      }
      return
    }

    if (!resolvedSubsidiaryId) {
      setHasNoAccess(true)
      return
    }

    setHasNoAccess(false)

    if (String(currentSubsidiaryId) !== resolvedSubsidiaryId) {
      dispatch(savePrevPath(`${location.pathname}${location.search}`))
      saveSubsidiary({
        subsidiaryId: resolvedSubsidiaryId
      })
      dispatch(postAndSelectSubsidiary(resolvedSubsidiaryId))
    }
  }, [
    currentSubsidiaryId,
    currentSubsidiaryList.length,
    dispatch,
    isLoggedIn,
    isSubsidiaryPosting,
    location.pathname,
    location.search,
    resolvedSubsidiaryId,
    subsidiaryListError
  ])

  if (!isLoggedIn && prevPath !== location.pathname) {
    saveSubsidiary({ subsidiaryId: idFromUrl })

    return <Redirect to="/login" />
  }

  if (!isLoggedIn) {
    dispatch(savePrevPath(`${location.pathname}${location.search}`))
    return <Redirect to="/login" />
  }

  if (hasNoAccess) {
    return (
      <div>
        You don't have access to this. <Link to="/">Go back home</Link>.{' '}
      </div>
    )
  }

  if (
    resolvedSubsidiaryId &&
    String(currentSubsidiaryId) === resolvedSubsidiaryId
  ) {
    // eslint-disable-next-line no-unused-vars
    const [_r, pathname, search = ''] = pathToGo.match(/([^?]+)(\?.*)?/)

    return <Redirect to={{ pathname, search }} />
  }

  return (
    <div className="full-screen-loading">
      <LoadingIndicator />
    </div>
  )
}

export default SwitchToHotelAndGoToPath
